var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHome = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.4,
    height: 22.329,
    viewBox: "0 0 20.4 22.329",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home_1_",
    "data-name": "home (1)",
    transform: "translate(-30.814 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10139",
    "data-name": "Grupo 10139",
    transform: "translate(30.814 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5543",
    "data-name": "Caminho 5543",
    d: "M50.953,14.069,41.29,5.211a.806.806,0,0,0-1.105.016l-9.126,8.858a.806.806,0,0,0-.245.578V26.524a.805.805,0,0,0,.805.805h6.71a.805.805,0,0,0,.805-.805V20.618h3.758v5.905a.805.805,0,0,0,.805.805h6.71a.805.805,0,0,0,.805-.805V14.663A.806.806,0,0,0,50.953,14.069Z",
    transform: "translate(-30.814 -5)",
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/home.ed086c7db0d771c35ce57df5b9d4dd00.svg";